module.exports = __webpack_public_path__ + "img/celtic.3776d127.png";